import React from "react";

import InputSelect from "../../../components/InputSelect";

/**
 * A select in the app's style (components/InputSelect, react-select): options keep their own
 * value type, since InputSelect works with string ids.
 */
const OptionSelect = ({ options, value, onChange, required, invalid, readOnly }: {
    options: Array<{ value: any; label: string }>;
    value: any;
    onChange: (value: any) => void;
    required?: boolean;
    invalid?: boolean;
    readOnly?: boolean;
}) => {
    const items = options.map((o) => ({ uuid: String(o.value), name: o.label }));

    return (
        <InputSelect
            items={items}
            value={value === undefined || value === null || value === '' ? null : String(value)}
            placeholder="—"
            onChange={(option: any) => {
                const picked = option ? options.find((o) => String(o.value) === option.value) : undefined;
                onChange(picked ? picked.value : null);
            }}
            isClearable={!required}
            required={!!required}
            readonly={!!readOnly}
            isLoading={false}
            className={invalid ? 'is-invalid z-index-auto zindex-3' : undefined}
        />
    );
};

export default OptionSelect;
